module.exports = function($) {

    /**
     *
     */
    class Dropdown{

        constructor(element){
            this.element = element;
            this.onClick();
        }

        /**
         *
         */
        onClick(){
            let _this = this;
            $(`${this.element} .selected`).on('click',function(){
                $(this).closest(_this.element).toggleClass('open');
            });
            $(`${this.element} .options div`).on('click',function(){
                let text = $(this).text();
                $(`${_this.element} .selected`).text(text);
                $(`${_this.element}`).toggleClass('open');
            });
        }

    }


    new Dropdown('.labels-grid .dropdown');
    new Dropdown('.menu-mobile .dropdown');
}
